import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BreadcrumbsService } from "src/app/services/breadcrumbs.service";

@Component({
    selector: "zx-breadcrumbs",
    templateUrl: "./zx-breadcrumbs.component.html",
    styleUrls: ["./zx-breadcrumbs.component.scss"],
    imports: [CommonModule, RouterModule]
})
export class ZxBreadcrumbsComponent {
    breadcrumbsService = inject(BreadcrumbsService);

    shouldShowBreadcrumbs = true;
}
